<div class="switch-container">
  @if (labelLeft) {
    <hyperkit-typography
      display="inline"
      variant="emphasized"
      size="sm"
      align="left"
      color="primary"
      >{{ labelLeft }}</hyperkit-typography
      >
    }
    <label class="switch">
      <input
        type="checkbox"
        [checked]="isChecked"
        [disabled]="disabled"
        (change)="onToggle()"
        />
      <span class="slider"></span>
    </label>
    @if (labelRight) {
      <hyperkit-typography
        display="inline"
        variant="emphasized"
        size="sm"
        align="left"
        color="primary"
        >{{ labelRight }}</hyperkit-typography
        >
      }
    </div>
